import chinaAreaData from 'china-area-data'

const ROOT_CODE = '86'
const ZHEJIANG_CODE = '330000'

export const provinceData = chinaAreaData[ROOT_CODE] || {}

export { chinaAreaData }

export const codeTextMap = Object.entries(chinaAreaData).reduce((map, [parentCode, data]) => {
  if (parentCode !== ROOT_CODE && data && typeof data === 'object') {
    Object.entries(data).forEach(([code, name]) => {
      map[code] = name
    })
  }
  return map
}, {})

export function buildChinaAreaOptions() {
  return sortedProvinceEntries().map(([provinceCode, provinceName]) => ({
    value: provinceCode,
    label: provinceName,
    children: buildChildren(provinceCode)
  }))
}

export function closeChinaAreaCascaderAfterDistrict(cascader, value) {
  if (!Array.isArray(value) || value.length < 3) {
    return
  }
  if (typeof cascader?.togglePopperVisible === 'function') {
    cascader.togglePopperVisible(false)
    return
  }
  if (typeof cascader?.handleClose === 'function') {
    cascader.handleClose()
    return
  }
  if (typeof cascader?.blur === 'function') {
    cascader.blur()
  }
}

function sortedProvinceEntries() {
  const entries = Object.entries(provinceData)
  const zhejiangIndex = entries.findIndex(([code]) => code === ZHEJIANG_CODE)
  if (zhejiangIndex <= 0) {
    return entries
  }
  const [zhejiang] = entries.splice(zhejiangIndex, 1)
  return [zhejiang, ...entries]
}

function buildChildren(parentCode) {
  const children = chinaAreaData[parentCode]
  if (!children || typeof children !== 'object') {
    return []
  }
  return Object.entries(children).map(([code, label]) => ({
    value: code,
    label,
    children: buildChildren(code)
  }))
}
